/**
 * Lời gọi API cho danh mục hành chính ba cấp và ba trợ lý tổ chức lại (đổi tên,
 * sáp nhập, chia tách) — MH-36 — và danh mục lĩnh vực bản tin — MH-37. Đợt 3
 * phần C4. Khớp đúng `apps/api/src/danh-muc/danh-muc.controller.ts`.
 *
 * Không có điểm cuối "xem ảnh hưởng" riêng: cả ba trợ lý dùng CHUNG một điểm cuối
 * hành động — gọi với `xacNhan` vắng/false trả về bản xem trước (số thiết bị/bản
 * tin/lịch phát bị ảnh hưởng), gọi lại với `xacNhan: true` mới thực sự ghi.
 */
import { goi, LoiApi } from './goi-chung';

export { LoiApi };

export interface DongDonVi {
  id: string;
  maDinhDanh: string;
  ten: string;
  cap: 'tinh' | 'xa' | 'thon';
  maCha: string | null;
  trangThai: string;
}

export interface AnhHuong {
  soThietBi: number;
  soBanTin: number;
  soLichPhat: number;
}

export type XuLyLichSu = 'giu_nguyen' | 'gan_lai';

/** Một dòng gửi lên khi nhập danh mục từ tệp. */
export interface DongNhapDonVi {
  maDinhDanh: string;
  ten: string;
  cap?: string;
  maCha?: string;
}

export interface KetQuaNhapDonVi {
  apDung: boolean;
  tongDong: number;
  soThemMoi: number;
  soDaCo: number;
  khacTen: { maDinhDanh: string; tenHienTai: string; tenTrongTep: string }[];
  tuThemTinh: boolean;
  soLoi: number;
  loi: { chiSo: number; maDinhDanh: string; loi: string }[];
  mauThemMoi: { maDinhDanh: string; ten: string; cap: string }[];
}

export const danhMucApi = {
  cay(signal?: AbortSignal): Promise<DongDonVi[]> {
    return goi('/api/v1/danh-muc/don-vi-hanh-chinh', { signal });
  },
  /** Nhập từ tệp: `xacNhan` vắng/false → xem trước; true → thêm đơn vị mới. */
  nhap(than: { dong: DongNhapDonVi[]; xacNhan?: boolean }): Promise<KetQuaNhapDonVi> {
    return goi('/api/v1/danh-muc/don-vi-hanh-chinh/nhap', { phuongThuc: 'POST', than });
  },
  suaTruongCoBan(id: string, than: { ten?: string; maDinhDanh?: string }): Promise<void> {
    return goi(`/api/v1/danh-muc/don-vi-hanh-chinh/${id}`, { phuongThuc: 'PATCH', than });
  },
  doiTen(id: string, than: { tenMoi: string; xacNhan?: boolean }): Promise<{ apDung: boolean } & AnhHuong> {
    return goi(`/api/v1/danh-muc/don-vi-hanh-chinh/${id}/doi-ten`, { phuongThuc: 'POST', than });
  },
  sapNhap(than: {
    nguonIds: string[];
    maMoi: string;
    tenMoi: string;
    xuLyLichSu: XuLyLichSu;
    xacNhan?: boolean;
  }): Promise<{ apDung: boolean } & AnhHuong> {
    return goi('/api/v1/danh-muc/don-vi-hanh-chinh/sap-nhap', { phuongThuc: 'POST', than });
  },
  chiaTach(than: {
    nguonId: string;
    donViMoi: { maMoi: string; tenMoi: string }[];
    phanCong: { maCu: string; maMoiChiDinh: string }[];
    xuLyLichSu: XuLyLichSu;
    xacNhan?: boolean;
  }): Promise<{ apDung: boolean } & AnhHuong> {
    return goi('/api/v1/danh-muc/don-vi-hanh-chinh/chia-tach', { phuongThuc: 'POST', than });
  },

  /* ---------------------------- Lĩnh vực bản tin --------------------------- */
  danhSachLinhVuc(signal?: AbortSignal): Promise<DongLinhVuc[]> {
    return goi('/api/v1/danh-muc/linh-vuc-ban-tin', { signal });
  },
  themLinhVuc(than: { ma: string; ten: string; anhXaLoaiLinhVuc: string }): Promise<void> {
    return goi('/api/v1/danh-muc/linh-vuc-ban-tin', { phuongThuc: 'POST', than });
  },
  ngungSuDungLinhVuc(id: number): Promise<void> {
    return goi(`/api/v1/danh-muc/linh-vuc-ban-tin/${id}/ngung-su-dung`, { phuongThuc: 'POST' });
  },
  kichHoatLaiLinhVuc(id: number): Promise<void> {
    return goi(`/api/v1/danh-muc/linh-vuc-ban-tin/${id}/kich-hoat-lai`, { phuongThuc: 'POST' });
  },
  xoaLinhVuc(id: number): Promise<void> {
    return goi(`/api/v1/danh-muc/linh-vuc-ban-tin/${id}`, { phuongThuc: 'DELETE' });
  },
};

export interface DongLinhVuc {
  id: number;
  ma: string;
  ten: string;
  anhXaLoaiLinhVuc: string;
  trangThai: 'hoat_dong' | 'ngung_su_dung';
  laGiaTriChuan: boolean;
}
